import { type Option } from 'core/domain/Option'

import { type Place } from '../domain/Place'

export function formatDescription(place?: Place): string {
  return place?.description || 'Anywhere'
}

export function formatToOption({ description }: Place): Option {
  return { label: description, value: description }
}
